<template>
  <div id="app">
    <div
      v-if="isStagingPreview"
      class="staging-banner__container"
      role="alert"
      aria-live="polite"
    >
      <p>
        <b>Staging preview</b>: Some changes may be unfinished. Please use the
        <a href="https://ark.sandbox.soenergy.co/">sandbox environment</a>.
      </p>
    </div>
    <div
      v-if="isWarmHomeDiscountPage"
      class="retirement-banner__container"
      role="status"
    >
      <p>
        ℹ️ <b>Warm Home Discount is moving to Nova.</b> This page will soon be
        available from Nova, and this application will then be retired. If you
        have any questions, please contact Colin Frankish or Will Daniels.
      </p>
    </div>
    <div v-else class="retirement-banner__container" role="alert">
      <p>
        ⚠️ <b>This application is being retired.</b> If you still use any part
        of it (apart from Warm Home Discount, which will soon be moved to Nova),
        please contact Colin Frankish or Will Daniels by
        <b>Wednesday 11 November 2026</b>.
      </p>
    </div>
    <Navbar @open="openSidebarPanel" />
    <SidebarSlideMenu
      :show-panel="showSidebarPanel"
      @close="closeSidebarPanel"
    />
    <router-view></router-view>
  </div>
</template>

<script>
const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`,
}

import Navbar from "@/components/Menu/Navbar"
import SidebarSlideMenu from "@/components/Menu/SidebarSlideMenu"
import authentication from "./authentication"
export default {
  name: "App",
  components: {
    Navbar,
    SidebarSlideMenu,
  },
  data() {
    return {
      showSidebarPanel: false,
    }
  },
  computed: {
    isStagingPreview() {
      return process.env.VUE_APP_VERCEL_URL?.includes("staging")
    },
    isWarmHomeDiscountPage() {
      return this.$route.name === "manage-applications"
    },
    isAuthenticated() {
      return authentication.isAuthenticated()
    },
  },
  watch: {
    $route() {
      this.closeSidebarPanel()
    },
  },
  methods: {
    openSidebarPanel() {
      this.showSidebarPanel = true
    },
    closeSidebarPanel() {
      this.showSidebarPanel = false
    },
    logOut() {
      authentication.signOut()
    },
  },
}
</script>

<style lang="scss" scoped>
.staging-banner {
  &__container {
    height: 40px;
    width: 100%;
    padding: 8px;
    text-align: center;
    color: black;
    background-color: $yellow-300;
    font-size: $size-7;
    overflow: hidden;

    & a {
      color: inherit;
    }
  }
}

.retirement-banner {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
    width: 100%;
    padding: 12px;
    text-align: center;
    color: black;
    background-color: $yellow-300;
    font-size: $size-6;

    & p {
      margin: 0;
    }
  }
}
</style>
